export default function (letter = 'a') {
    return new Promise((resolve, reject) => {
        jQuery.get({
            url: `/wp-json/wp/v2/item?_embed=true&lang=uk&per_page=9&start_with=${letter}`,
            success: function(response) {
                resolve(response);
            },
            error: function(error) {
                reject(error);
            }
        });
    });
}